/* Reference https://vee-validate.logaretm.com/v4/guide/global-validators#alpha */
import { defineRule, configure } from 'vee-validate'
import { all as rules } from '@vee-validate/rules'
import defineCustomRule from '~/utils/validation-rules'
import { localize } from '@vee-validate/i18n'
import ko from '@/locales/ko/validate'

export default defineNuxtPlugin({
  async setup(_nuxtApp) {
    Object.entries(rules).forEach(([rule, value]: [string, any]) => {
      defineRule(rule, value)
    })
    defineCustomRule()

    configure({ generateMessage: localize('ko', ko) })
  },
})
